import { currentProfileState } from 'components/company-profile/state/current-profile';
import { useSnapshot } from 'hooks/use-safe-snapshot';

const useCurrentProfile = () => {
    const { profile } = useSnapshot(currentProfileState);

    return profile;
};

export { useCurrentProfile };
